import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useMasksState = () => React.useContext(Context) || {}
export const useMasks = () => useMasksState()?.masks || []

const QUERY = gql`
  query Masks($page: Int, $limit: Int, $search: String, $sort: MaskSort, $filter: MaskFilter) {
    masks(page: $page, limit: $limit, search: $search, sort: $sort, filter: $filter) {
      id
      name
      pattern
      enabled
      deleted
      insertedAt
      updatedAt
    }
  }
`

const MasksLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()

  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const response = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...filter, includeDisabled: true },
      fetchPolicy: 'cache-first'
    },
    client: generalClient
  })

  const { data, fetchMore, variables, ...state } = response

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default MasksLoader
